/**
 * Unique `{id, name}` rows in first-seen order.
 *
 * Params
 * - items (Array): Rows with `id` and `name`. Missing ids and later
 *   duplicates are dropped.
 *
 * Returns
 * - Array: First-seen unique rows.
 *
 * @param {?Array<{id: *, name: string}>} items
 * @return {!Array<{id: *, name: string}>}
 */
export const uniqueNamedItems = items => {
  const seen = new Set();
  return (items ?? []).filter(item => {
    if (!item?.id || seen.has(item.id)) return false;
    seen.add(item.id);
    return true;
  });
};
